/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_Choose_GatewayInputs */



/**
* | output |
* | --- |
* | "Select a box" |
*
* @param {Mesh_Test_Choose_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_choose_gateway = /** @type {((inputs?: Mesh_Test_Choose_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_Choose_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select a box")
	return /** @type {LocalizedString} */ ("Sélectionnez une box")
});